import { useEffect, useRef, useState } from 'react';

export const useWakeLock = (enabled = true) => {
    const wakeLockRef = useRef(null);
    const [isLocked, setIsLocked] = useState(false);

    useEffect(() => {
        if (!enabled) return;

        const requestWakeLock = async () => {
            try {
                if ('wakeLock' in navigator) {
                    wakeLockRef.current = await navigator.wakeLock.request('screen');
                    setIsLocked(true);

                    wakeLockRef.current.addEventListener('release', () => {
                        setIsLocked(false);
                    });
                }
            } catch (err) {
                console.error(`${err.name}, ${err.message}`);
            }
        };

        const handleVisibilityChange = () => {
            if (wakeLockRef.current !== null && document.visibilityState === 'visible') {
                requestWakeLock();
            }
        };

        requestWakeLock();
        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
            if (wakeLockRef.current) {
                wakeLockRef.current.release().catch(() => { });
                wakeLockRef.current = null;
            }
        };
    }, [enabled]);

    return isLocked;
};
